import { render, staticRenderFns } from "./FiltroTexto.vue?vue&type=template&id=0b207eed&"
import script from "./FiltroTexto.vue?vue&type=script&lang=ts&"
export * from "./FiltroTexto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports